import React, { useCallback, useMemo } from 'react'

import {
  PaywallModal,
  PaywallModalComponentId,
} from '@/components/common/modals/PaywallModal'

export type PaywallOptions = { callToActionHref: string }

type UsePaywallModalProps = [
  PaywallModal: JSX.Element,
  showPaywallModal: (
    id: PaywallModalComponentId,
    options?: PaywallOptions
  ) => void,
  hidePaywallModal: () => void,
]

export type PaywallState = {
  componentId: PaywallModalComponentId
  callToActionHref: string
}

export function usePaywallModal(): UsePaywallModalProps {
  const [paywall, setPaywall] = React.useState<PaywallState>({
    componentId: undefined,
    callToActionHref: '',
  })

  const hidePaywallModal = useCallback(() => setPaywall(undefined), [])

  const showPaywallModal = useCallback(
    (id: PaywallModalComponentId, options: PaywallOptions): void | null => {
      setPaywall({
        componentId: id,
        callToActionHref: options?.callToActionHref,
      })
    },
    []
  )

  const PaywallModalComponent = useMemo(
    () => (
      <PaywallModal
        onCancel={hidePaywallModal}
        onOk={hidePaywallModal}
        open={!!paywall?.componentId}
        paywall={paywall}
      />
    ),
    [paywall, hidePaywallModal]
  )

  return [PaywallModalComponent, showPaywallModal, hidePaywallModal]
}
